import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/API/api.service';
import * as $ from 'jquery';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit, AfterViewInit {

  categoryID: any
  categoryName = ''
  products: any
  subCategoryImage = ''
  productsLength = 0
  categoryImage = ''
  vendorName = ''
  filterForm: FormGroup
  isLoading = false

  constructor(private api: ApiService, 
    private url: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private encrypt: EncryptionService) {
    this.filterForm = this.formBuilder.group({
      method: ['',[Validators.required]],
      desc: ['desc'],
      products: this.formBuilder.array
    })
  }

  ngOnInit(): void {
    if(this.url.snapshot.params['subCatID']){
      this.categoryID = this.url.snapshot.params['subCatID'];
      this.categoryID = this.decodeHash(this.categoryID)
      this.categoryName = this.url.snapshot.params['subCatName']
      this.subCategoryImage = sessionStorage.getItem('subImage')
      this.categoryImage = sessionStorage.getItem('categoryImage')
      this.vendorName = sessionStorage.getItem('vendorName')
      // console.log(this.vendorID)
    }

    if(this.categoryID){
      this.api.allSubCategoryProducts(this.categoryID,1).subscribe({
        next: (response: any) => {
          this.products = response.data.data
          this.products.map((product: any) => {
            product.hashedId = this.generateHash(product.id.toString());
          });
          this.productsLength = this.products.length
          console.log(this.products)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }

  }

  ngAfterViewInit(): void {
    $('.inner-bg3').css('background-image',`url(${this.subCategoryImage})`)
  }

  changeValue(text: string){
    this.filterForm.patchValue({
      method: text
    })
  }

  onSubmit(){
    this.isLoading = true
    this.api.allSubCategoryProducts(this.categoryID,1).subscribe({
      next: (response: any) => {
        this.products = response.data.data
        if(this.filterForm.valid){
          this.filterForm.patchValue({
            products: this.products
          })
          this.api.filter(this.filterForm.value).subscribe({
            next: (response: any) => {
              this.products = response.data
              this.products.map((product: any) => {
                product.hashedId = this.generateHash(product.id.toString());
              });
              this.isLoading = false
            }, error: (error: HttpErrorResponse) => {
              console.log(error)
            }
          })
        }
        console.log(this.products)
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  clearFilter(){
    this.api.allSubCategoryProducts(this.categoryID,1).subscribe({
      next: (response: any) => {
        this.products = response.data.data
        this.products.map((product: any) => {
          product.hashedId = this.generateHash(product.id.toString());
        });
        this.productsLength = this.products.length
        console.log(this.products)
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  decodeHash(hashedId: string): string | null {
    return this.encrypt.decryptionAES(hashedId);
  }

  generateHash(id: string): string {
    return this.encrypt.encryptionAES(id)
  }
}
